import { render, staticRenderFns } from "./MainMenuSulut.vue?vue&type=template&id=57034dea&lang=pug"
import script from "./MainMenuSulut.vue?vue&type=script&lang=js"
export * from "./MainMenuSulut.vue?vue&type=script&lang=js"
import style0 from "../../../assets/style/sulut/menu-slt.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports